import DomElementsBase from "@grindex-common/abstracts/DomElementsBase.class";

const SLIDER_SELECTOR = "ul.cardSlider";
const FLIPPABLE_CARD_SELECTOR = ".flippable-card";
const SECTION_SELECTOR = "li section";

export default class ContentDetailPageElements extends DomElementsBase {
	constructor($module) {
		const selectors = [SLIDER_SELECTOR, FLIPPABLE_CARD_SELECTOR, SECTION_SELECTOR];

		super($module, selectors);
	}

	sliders() {
		return this.getElements(SLIDER_SELECTOR);
	}

	flippableCard(slider) {
		return slider.querySelectorAll(FLIPPABLE_CARD_SELECTOR);
	}

	sections(slider) {
		return slider.querySelectorAll(SECTION_SELECTOR);
	}
}
